import { t } from "i18next";

import { GENERAL_ONBOARDING_STEPS } from "./constants";
import HelpScreen from "./HelpScreen";

export const createSteps = (
  onboardingSteps,
  setCurrentStep,
  currentStep,
  helpScreenClassName
) => {
  const helpStep = {
    key: GENERAL_ONBOARDING_STEPS.HELP,
    label: t("neetoMolecules.onboarding.helpLabel"),
    element: (
      <HelpScreen {...{ currentStep, helpScreenClassName, setCurrentStep }} />
    ),
  };

  return onboardingSteps
    .concat(helpStep)
    .map((step, idx) => ({ ...step, id: idx + 1 }));
};

export const getWindowDimensions = () =>
  typeof window !== "undefined"
    ? { width: window.innerWidth, height: window.innerHeight }
    : { width: 100, height: 100 };
